// Dobavih begin i vote kato kategorii za da gi tyrsq direktno po Id
export enum CATEGORIES {
	BEGIN = 0,
	BG_PESEN = 1,
	BG_TEKST = 2,
	BG_ALBUM = 3,
	BG_IZPALNITEL = 4,
	BG_IZPALNITELKA = 5,
	BG_VOKALNA_GRUPA = 6,
	BG_KOMBINACIA = 7,
	BG_GRUPA = 8,
	BG_DEBUT = 9,
	BG_VIDEOKLIP = 10,
	VOTE = 11
}

export const CategoryData = {
	[CATEGORIES.BEGIN]: {
		key: CATEGORIES.BEGIN,
		title: "Начало",
		vote: {}
	}, [CATEGORIES.BG_PESEN]: {
		key: CATEGORIES.BG_PESEN,
		title: "БГ Песен",
		vote: {}
	},
	[CATEGORIES.BG_TEKST]: {
		key: CATEGORIES.BG_TEKST,
		title: "БГ Текст",
		vote: {}
	},
	[CATEGORIES.BG_ALBUM]: {
		key: CATEGORIES.BG_ALBUM,
		title: "БГ Албум",
		vote: {}
	},
	[CATEGORIES.BG_IZPALNITEL]: {
		key: CATEGORIES.BG_IZPALNITEL,
		title: "БГ Изпълнител",
		vote: {}
	},
	[CATEGORIES.BG_IZPALNITELKA]: {
		key: CATEGORIES.BG_IZPALNITELKA,
		title: "БГ Изпълнителка",
		vote: {}
	},
	[CATEGORIES.BG_VOKALNA_GRUPA]: {
		key: CATEGORIES.BG_VOKALNA_GRUPA,
		title: "БГ Дует/Трио/Вокална група",
		vote: {}
	},
	[CATEGORIES.BG_KOMBINACIA]: {
		key: CATEGORIES.BG_KOMBINACIA,
		title: "БГ Комбинация",
		vote: {}
	},
	[CATEGORIES.BG_GRUPA]: {
		key: CATEGORIES.BG_GRUPA,
		title: "БГ Група",
		vote: {}
	},
	[CATEGORIES.BG_DEBUT]: {
		key: CATEGORIES.BG_DEBUT,
		title: "БГ Дебют",
		vote: {}
	},	[CATEGORIES.BG_VIDEOKLIP]: {
		key: CATEGORIES.BG_VIDEOKLIP,
		title: "БГ Видеоклип",
		vote: {}
	}, [CATEGORIES.VOTE]: {
		key: CATEGORIES.VOTE,
		title: "Регистрация",
		vote: {}
	},
};